import { z } from 'zod'

export const ProductPrice = z.object({
  id: z.number().int(),
  amount: z.number().int().optional(),
  currency: z.string().max(3).optional(),
  description: z.string().optional(),
  active: z.boolean().optional().default(true),
  default: z.boolean().optional().default(true),
  tax: z.number().optional(),
  // Gross cents for a whole cycle where it is not amount times the months, e.g. { annually: 1990 }.
  cycle_amounts: z.record(z.string(), z.number().int().positive()).optional()
})

export type ProductPrice = z.infer<typeof ProductPrice>
